/* eslint-disable max-len */
import React from 'react'

import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import moment from 'moment'
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion'

const TableBody=({
    tableData,
    indexNum,
})=>{
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const fieldTOUpdate={
        'user_type':'User Type',
        'user_name':'Username',
        'organization_id':'Organization ID',
        'organization_name':'Organization Name',
        'name':'Sub Division Name',
        'organization_address':'Organization Address',
        'value_added':'Value Added',
        'direct_billing':'Direct Billing',
        'main_number':'Main Number',
        'mobile_number':'Mobile Number',
        'email_address':'Email Address',
        'last_name':'Last Name',
        'first_name':'First Name',
        'Profile Page':'Profile Page',
        "subdivision_id":'Sub Division ID',
        'address':'Organization Address',
        'sub_divisions.name':'Sub Division Name',
        'sub_divisions.vital_collection_timing.time_period':'Time Period of Vital Collection',
        'vital_collection_timing.time_period':'Time Period of Vital Collection',
        'sub_divisions.vital_collection_timing.number_of_readings':'No. of Readings of Vital Collection',
        'vital_collection_timing.number_of_readings':'No. of Readings of Vital Collection',
        'sub_divisions.wellness_timing.time_period':'Time Period of Wellness',
        'wellness_timing.time_period':'Time Period of Wellness',
        'sub_divisions.vital_collection_timing.number_of_time_periods':'No. of Time Periods of Vital Collection',
        'vital_collection_timing.number_of_time_periods':'No. of Time Periods of Vital Collection',
        'sub_divisions.subdivision_id':'Sub Division ID',
        'sub_divisions.point_of_contact_person.main_number':'POC Main Number',
        'point_of_contact_person.main_number':'POC Main Number',
        'sub_divisions.wellness_timing.number_of_time_periods':'No.of Timeperiods of Wellness',
        'wellness_timing.number_of_time_periods':'No.of Timeperiods of Wellness',
        'sub_divisions.wellness_timing.number_of_minutes':'No. of Minutes of Wellness',
        'wellness_timing.number_of_minutes':'No. of Minutes of Wellness',
        'sub_divisions.point_of_contact_person.mobile_number':'POC Mobile Number',
        'point_of_contact_person.mobile_number':'POC Mobile Number',
        'sub_divisions.point_of_contact_person.email_address':'POC Email Address',
        'point_of_contact_person.email_address':'POC Email Address',
        'sub_divisions.corporate_users':'Corporate Users',
        'sub_divisions.monitor_user_list':'Monitor Users',
        'sub_divisions.point_of_contact_person.name':'POC Name',
        'point_of_contact_person.name':'POC Name'

    }
    
    
    
    const date = convertEpochToDateFormat(tableData?.timestamp,dateformat)
    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {tableData?.user_name}
                        </td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {date}
                        </td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{tableData?.action}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{tableData?.field?.includes('corporate_users')?'Corporate Users':tableData?.field?.includes('monitor_user_list')?'Monitor Users':fieldTOUpdate[tableData?.field]?fieldTOUpdate[tableData?.field]:tableData?.field}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{tableData?.target_subdivision?tableData?.target_subdivision:"-"}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{tableData?.old_value===''|| tableData?.old_value===null ? '-' : tableData?.old_value?.toString()==='true'?'True':tableData?.old_value?.toString()==='false'?'False':tableData?.old_value?.toString()}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{tableData?.new_value==='' ?'-':tableData?.new_value==="corporate-user"?'Corporate User':tableData?.new_value==="admin-user"?'Admin User':tableData?.new_value?.toString()==='true'?'True':tableData?.new_value?.toString()==='false'?'False':tableData?.new_value?.toString()}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-sm rounded-bl-sm">{tableData?.comments===''?'-':tableData?.comments}</td>
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBody